module.exports = __webpack_public_path__ + "img/video.c7ba26b0.png";